import React, { useRef, useState, useEffect, useContext } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { format } from "date-fns";
import { ListItemText } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { MyDomain } from "../../App";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));
const textFieldStyles = {
  "& .MuiInput-underline:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.5,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:hover:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.8,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#6366f1",
    borderBottomWidth: "1px",
  },
  "& .MuiInputBase-root": {
    fontSize: "14px",
  },
};

// Custom theme to override MenuItem and Select styles
const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#e5e5e5", // Change selected option background color to gray
            "&:hover": {
              backgroundColor: "#e5e5e5", // Keep the same color on hover
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingLeft: 0, // Remove left padding
          textAlign: "left", // Align text to the left
        },
      },
    },
  },
});
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function AdminNewsCreate() {
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [Brands, setBrands] = useState([]);
  const [AdSectionData, setAdSectionData] = useState([]);
  const [AdTopSectionData, setAdTopSectionData] = useState([]);

  const [height, width] = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    console.log("aa");
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(
        `${MyDomain}News/GetAllDataToCreateNews`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          //params: { Id: User.userId },
        }
      );
      console.log(response.data);
      const newArray = response.data.brands.map((item) => ({
        value: item.name,
        label: item.name,
      }));
      setBrands(newArray);
      const newArray2 = response.data.giftsProducts.map((item) => ({
        value: item.id.toString(),
        label: item.name,
      }));
      setIdsOfGifts(newArray2);

      // const newArray3 = response.data.adSection.map((item) => ({
      //   value: item.id.toString(),
      //   label: item.name,
      // }));
      setAdSectionData(response.data.adSection);
      // const newArray4 = response.data.adTopSection.map((item) => ({
      //   value: item.id.toString(),
      //   label: item.name,
      // }));
      setAdTopSectionData(response.data.adTopSection);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err.response.data.error);
      setLoading(false);
    }
  };

  const [IdsOfGifts, setIdsOfGifts] = useState([]);
  const [loading2, setLoading2] = useState(true);
  const [error2, setError2] = useState(null);

  const today = new Date();
  const formattedDate = format(today, "dd-MM-yyyy");
  const [CheckDepartment, setCheckDepartment] = useState(true);

  const SelectStyles = {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom:
        CheckDepartment === false ? "1px solid red" : "1px solid #ccc",
      borderRadius: 0,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom: "1px solid #a1a1aa",
      borderRadius: 0,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom: "1px solid #a1a1aa",
      borderRadius: 0,
    },
    "& .MuiSelect-select": {
      paddingLeft: 0,
      textAlign: "left",
      fontSize: 14,
    },
  };
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    fetchData();
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { User, Token } = useAppContext();
  const history = useHistory();

  const [open, setOpen] = useState(false); //false
  const handleClose = () => {
    setOpen(false);
  };
  const [ProductOBJ, setProductOBJ] = useState({
    //codeCat: , // code can automatic do it in c# same id
    title: "", //i will show it in news page for every news looks like (Boss, Loreal)
    disc1: "", // easy
    disc2: "", // easy
    disc3: "", // easy
    image: "", // easy
    dateStart: null,
    dateEnd: null,
    brand: "",
    typeOffer: null, // for now we have 5 types of offer
    actionsFilter: "", //this will be for in page special offers to filter for example (Perfumes)
    spendMoney: 0,
    discount: 0,
    idsOfGifts: "", //103, 104
    typeOfferName: "", //SECOND ITEM DISCOUNT
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setProductOBJ((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // for gifts
  const selectedValues = ProductOBJ.idsOfGifts
    ? ProductOBJ.idsOfGifts.split(",")
    : [];
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // Convert array back to string for your state
    const newValue = typeof value === "string" ? value : value.join(",");

    setProductOBJ((prev) => ({
      ...prev,
      idsOfGifts: newValue,
    }));
  };

  //End for gifts

  // for title
  const selectedValuesTitle = ProductOBJ.title
    ? ProductOBJ.title.split(",")
    : [];
  const [searchTermTitle, setSearchTermTitle] = useState("");

  const handleChangeTitle = (event) => {
    const {
      target: { value },
    } = event;

    // Convert array back to string for your state
    const newValue = typeof value === "string" ? value : value.join(",");

    setProductOBJ((prev) => ({
      ...prev,
      title: newValue,
    }));
  };

  //End for title

  // for brand
  const selectedValuesBrands = ProductOBJ.brand
    ? ProductOBJ.brand.split(",")
    : [];
  const [searchTermBrands, setSearchTermBrands] = useState("");

  const handleChangeBrands = (event) => {
    const {
      target: { value },
    } = event;

    // Convert array back to string for your state
    const newValue = typeof value === "string" ? value : value.join(",");

    setProductOBJ((prev) => ({
      ...prev,
      brand: newValue,
    }));
  };
  //End for brand

  // for idsOfGifts

  const selectedValuesIdsOfGifts = ProductOBJ.idsOfGifts
    ? ProductOBJ.idsOfGifts.split(",")
    : [];
  const [searchTermIdsOfGifts, setSearchTermIdsOfGifts] = useState("");

  const handleChangeIdsOfGifts = (event) => {
    const {
      target: { value },
    } = event;

    // Convert array back to string for your state
    const newValue = typeof value === "string" ? value : value.join(",");

    setProductOBJ((prev) => ({
      ...prev,
      idsOfGifts: newValue,
    }));
  };

  //End for idsOfGifts

  const TypeOffer = [
    {
      value: 1,
      label:
        "1- Buy more than (Y (total price)) from (X) brand products and get (X) as gift ",
    },
    { value: 2, label: "2- Buy 2 products from “Brand” and get a gift" },
    { value: 3, label: "3- 50% discount on “X” brand" },
    { value: 4, label: "4- Get 50% on second lowest price from “X” brand" },
    {
      value: 5,
      label:
        "5- Get the lowest product for free when buy three “X” brand products",
    },
  ];

  const ActionsFilter = [
    {
      value: "Perfume",
      label: "Perfume",
    },
    {
      value: "Makeup",
      label: "Makeup",
    },
    {
      value: "Hair",
      label: "Hair",
    },
    {
      value: "Face",
      label: "Face",
    },
    {
      value: "Bath and Body",
      label: "Bath and Body",
    },
    {
      value: "For Men",
      label: "For Men",
    },
    {
      value: "Accessories",
      label: "Accessories",
    },
    {
      value: "Health and Care",
      label: "Health and Care",
    },
    {
      value: "Gifts",
      label: "Gifts",
    },
  ];

  const TypeOfferName = [
    {
      value: "SPECIAL OFFER",
      label: "SPECIAL OFFER",
    },
    {
      value: "DISCOUNT",
      label: "DISCOUNT",
    },
    {
      value: "SECOND ITEM DISCOUNT",
      label: "SECOND ITEM DISCOUNT",
    },
  ];
  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = date.format("DD-MM-YYYY");
      setProductOBJ((prevState) => ({
        ...prevState,
        dateStart: formattedDate,
      }));
    }
  };

  const handleDateChange2 = (date) => {
    if (date) {
      const formattedDate = date.format("DD-MM-YYYY");
      setProductOBJ((prevState) => ({
        ...prevState,
        dateEnd: formattedDate,
      }));
    }
  };
  const searchInputRef = useRef(null);

  // Focus the search input when dropdown opens
  useEffect(() => {
    if (searchInputRef.current) {
      const timer = setTimeout(() => {
        searchInputRef.current.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [searchTerm]); // Re-run when searchTerm changes

  // console.log(ProductOBJ);

  const [Choose, setChoose] = useState(3);

  const ModalCreateNewProduct = () => {
    return (
      <div>
        <React.Fragment>
          {/* <Button variant="outlined" onClick={handleClickOpen}>
            Open dialog
          </Button> */}
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open} //open
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              CREATE NEW NEWS
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>

            <div
              style={{
                width: "100%",
                display: "flex",
                //flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  //height: "calc(90vh - 55px)",
                  //minHeight: "calc(60vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <TextField
                  id="standard-basic"
                  label="Title"
                  variant="standard"
                  name="title"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.title}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                /> */}
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Title
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="big-category-filter-label"
                        id="big-category-filter"
                        multiple
                        value={selectedValuesTitle}
                        onChange={handleChangeTitle}
                        renderValue={(selected) =>
                          selected
                            .map((val) => {
                              const item = Brands.find(
                                (option) => option.value === val
                              );
                              return item ? item.label : val;
                            })
                            .join(", ")
                        }
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                              maxHeight: 300,
                            },
                          },
                          // Disable focus management that interferes with search
                          disableAutoFocus: true,
                          disableEnforceFocus: true,
                          disableRestoreFocus: true,
                        }}
                        onOpen={() => setSearchTermTitle("")}
                      >
                        {/* Search input with focus management */}
                        <Box
                          sx={{
                            p: 1,
                            borderBottom: "1px solid #eee",
                            position: "sticky",
                            top: 0,
                            bgcolor: "background.paper",
                            zIndex: 1,
                          }}
                        >
                          <TextField
                            fullWidth
                            inputRef={searchInputRef}
                            placeholder="Search brands..."
                            value={searchTermTitle}
                            onChange={(e) => setSearchTermTitle(e.target.value)}
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                fontSize: "14px",
                                height: "32px",
                              },
                            }}
                            onKeyDown={(e) => e.stopPropagation()} // Prevent select from handling key events
                          />
                        </Box>

                        {/* Filtered options or no results message */}
                        {Brands.filter(
                          (option) =>
                            option.label
                              .toLowerCase()
                              .includes(searchTermTitle.toLowerCase()) ||
                            option.value
                              .toString()
                              .toLowerCase()
                              .includes(searchTermTitle.toLowerCase())
                        ).length === 0 ? (
                          <MenuItem disabled sx={{ p: 1 }}>
                            <Typography variant="body2" color="textSecondary">
                              No titles found matching "{searchTermTitle}"
                            </Typography>
                          </MenuItem>
                        ) : (
                          Brands.filter(
                            (option) =>
                              option.label
                                .toLowerCase()
                                .includes(searchTermTitle.toLowerCase()) ||
                              option.value
                                .toString()
                                .toLowerCase()
                                .includes(searchTermTitle.toLowerCase())
                          ).map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              <Checkbox
                                style={{ paddingTop: 3 }}
                                icon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  />
                                }
                                checkedIcon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 10,
                                        height: 10,
                                        backgroundColor: "black",
                                      }}
                                    />
                                  </Box>
                                }
                                checked={selectedValuesTitle.includes(
                                  option.value
                                )}
                                sx={{ padding: 0 }}
                              />
                              <ListItemText
                                primary={option.label}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: 14,
                                    margin: 0,
                                  },
                                }}
                              />
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>
                <TextField
                  id="standard-basic"
                  label="Description 1"
                  variant="standard"
                  name="disc1"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.disc1}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />

                <TextField
                  id="standard-basic"
                  label="Description 2"
                  variant="standard"
                  name="disc2"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.disc2}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />

                <TextField
                  id="standard-basic"
                  label="Description 3"
                  variant="standard"
                  name="disc3"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.disc3}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <TextField
                  id="standard-basic"
                  label="Image"
                  variant="standard"
                  name="image"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.image}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <div style={{ width: "100%", paddingBottom: 25 }}>
                  {/* Ensures the container is 100% width */}
                  <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
                    Date start
                  </p>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        ProductOBJ.dateStart
                          ? dayjs(ProductOBJ.dateStart, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(date) => handleDateChange(date, "dateStart")}
                      slotProps={{
                        textField: {
                          variant: "standard", // Removes outer border and keeps only the underline
                          InputProps: {
                            disableUnderline: false, // Ensure underline is shown
                          },
                          sx: {
                            width: "100%", // Enforces full width on the text field
                            "& .MuiInputBase-root:before": {
                              borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                            },
                            "& .MuiInputBase-root:hover:not(.Mui-disabled):before":
                              {
                                borderBottom: "1px solid black", // Underline color on hover
                              },
                            "& .MuiInputBase-root:after": {
                              borderBottom: "2px solid #1976d2 ", // Underline color when focused
                            },
                          },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            width: "100%", // Ensures TextField spans full width
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "red", // Default border color
                              },
                              "&:hover fieldset": {
                                borderColor: "red", // Hover border color
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "red", // Focus border color
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>

                <div style={{ width: "100%", paddingBottom: 25 }}>
                  {/* Ensures the container is 100% width */}
                  <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
                    Date end
                  </p>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        ProductOBJ.dateEnd
                          ? dayjs(ProductOBJ.dateEnd, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(date) => handleDateChange2(date, "dateEnd")}
                      slotProps={{
                        textField: {
                          variant: "standard", // Removes outer border and keeps only the underline
                          InputProps: {
                            disableUnderline: false, // Ensure underline is shown
                          },
                          sx: {
                            width: "100%", // Enforces full width on the text field
                            "& .MuiInputBase-root:before": {
                              borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                            },
                            "& .MuiInputBase-root:hover:not(.Mui-disabled):before":
                              {
                                borderBottom: "1px solid black", // Underline color on hover
                              },
                            "& .MuiInputBase-root:after": {
                              borderBottom: "2px solid #1976d2 ", // Underline color when focused
                            },
                          },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            width: "100%", // Ensures TextField spans full width
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "red", // Default border color
                              },
                              "&:hover fieldset": {
                                borderColor: "red", // Hover border color
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "red", // Focus border color
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Brand/s
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="big-category-filter-label"
                        id="big-category-filter"
                        multiple
                        value={selectedValuesBrands}
                        onChange={handleChangeBrands}
                        renderValue={(selected) =>
                          selected
                            .map((val) => {
                              const item = Brands.find(
                                (option) => option.value === val
                              );
                              return item ? item.label : val;
                            })
                            .join(", ")
                        }
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                              maxHeight: 300,
                            },
                          },
                          // Disable focus management that interferes with search
                          disableAutoFocus: true,
                          disableEnforceFocus: true,
                          disableRestoreFocus: true,
                        }}
                        onOpen={() => setSearchTermBrands("")}
                      >
                        {/* Search input with focus management */}
                        <Box
                          sx={{
                            p: 1,
                            borderBottom: "1px solid #eee",
                            position: "sticky",
                            top: 0,
                            bgcolor: "background.paper",
                            zIndex: 1,
                          }}
                        >
                          <TextField
                            fullWidth
                            inputRef={searchInputRef}
                            placeholder="Search brands..."
                            value={searchTermBrands}
                            onChange={(e) =>
                              setSearchTermBrands(e.target.value)
                            }
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                fontSize: "14px",
                                height: "32px",
                              },
                            }}
                            onKeyDown={(e) => e.stopPropagation()} // Prevent select from handling key events
                          />
                        </Box>

                        {/* Filtered options or no results message */}
                        {Brands.filter(
                          (option) =>
                            option.label
                              .toLowerCase()
                              .includes(searchTermBrands.toLowerCase()) ||
                            option.value
                              .toString()
                              .toLowerCase()
                              .includes(searchTermBrands.toLowerCase())
                        ).length === 0 ? (
                          <MenuItem disabled sx={{ p: 1 }}>
                            <Typography variant="body2" color="textSecondary">
                              No brands found matching "{searchTermBrands}"
                            </Typography>
                          </MenuItem>
                        ) : (
                          Brands.filter(
                            (option) =>
                              option.label
                                .toLowerCase()
                                .includes(searchTermBrands.toLowerCase()) ||
                              option.value
                                .toString()
                                .toLowerCase()
                                .includes(searchTermBrands.toLowerCase())
                          ).map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              <Checkbox
                                style={{ paddingTop: 3 }}
                                icon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  />
                                }
                                checkedIcon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 10,
                                        height: 10,
                                        backgroundColor: "black",
                                      }}
                                    />
                                  </Box>
                                }
                                checked={selectedValuesBrands.includes(
                                  option.value
                                )}
                                sx={{ padding: 0 }}
                              />
                              <ListItemText
                                primary={option.label}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: 14,
                                    margin: 0,
                                  },
                                }}
                              />
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>

                <div style={{ display: "flex", width: "100%" }}>
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Type offer
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{
                      paddingBottom: 30,
                      //width: MyWidth <= 1024 ? "90%" : "80%",
                      width: "100%",
                      fontSize: 10,
                      //paddingTop: 30,
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="Type offer"
                        id="standard-basic"
                        name="typeOffer" // Important: matches the property name in state
                        value={ProductOBJ.typeOffer}
                        onChange={handleInputChange} // Use the shared handler
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                            },
                          },
                        }}
                      >
                        {TypeOffer.map((option) => (
                          <MenuItem
                            key={option.value}
                            style={{ fontSize: 14 }}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>

                <div style={{ display: "flex", width: "100%" }}>
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Actions Filter
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{
                      paddingBottom: 30,
                      //width: MyWidth <= 1024 ? "90%" : "80%",
                      width: "100%",
                      fontSize: 10,
                      //paddingTop: 30,
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="Actions Filter"
                        id="standard-basic"
                        name="actionsFilter" // Important: matches the property name in state
                        value={ProductOBJ.actionsFilter}
                        onChange={handleInputChange} // Use the shared handler
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                            },
                          },
                        }}
                      >
                        {ActionsFilter.map((option) => (
                          <MenuItem
                            key={option.value}
                            style={{ fontSize: 14 }}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>

                <TextField
                  id="standard-basic"
                  label="Spend money"
                  variant="standard"
                  name="spendMoney"
                  type="number" // This restricts input to numbers
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*", // Ensures only numbers on mobile devices
                  }}
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.spendMoney}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <TextField
                  id="standard-basic"
                  label="Discount"
                  variant="standard"
                  name="discount"
                  type="number" // This restricts input to numbers
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*", // Ensures only numbers on mobile devices
                  }}
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.discount}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Gifts for offer
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="big-category-filter-label"
                        id="big-category-filter"
                        multiple
                        value={selectedValuesIdsOfGifts}
                        onChange={handleChangeIdsOfGifts}
                        renderValue={(selected) =>
                          selected
                            .map((val) => {
                              const item = IdsOfGifts.find(
                                (option) => option.value === val
                              );
                              return item ? item.label : val;
                            })
                            .join(", ")
                        }
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                              maxHeight: 300,
                            },
                          },
                          // Disable focus management that interferes with search
                          disableAutoFocus: true,
                          disableEnforceFocus: true,
                          disableRestoreFocus: true,
                        }}
                        onOpen={() => setSearchTermIdsOfGifts("")}
                      >
                        {/* Search input with focus management */}
                        <Box
                          sx={{
                            p: 1,
                            borderBottom: "1px solid #eee",
                            position: "sticky",
                            top: 0,
                            bgcolor: "background.paper",
                            zIndex: 1,
                          }}
                        >
                          <TextField
                            fullWidth
                            inputRef={searchInputRef}
                            placeholder="Search brands..."
                            value={searchTermIdsOfGifts}
                            onChange={(e) =>
                              setSearchTermIdsOfGifts(e.target.value)
                            }
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                fontSize: "14px",
                                height: "32px",
                              },
                            }}
                            onKeyDown={(e) => e.stopPropagation()} // Prevent select from handling key events
                          />
                        </Box>

                        {/* Filtered options or no results message */}
                        {IdsOfGifts.filter(
                          (option) =>
                            option.label
                              .toLowerCase()
                              .includes(searchTermIdsOfGifts.toLowerCase()) ||
                            option.value
                              .toString()
                              .toLowerCase()
                              .includes(searchTermIdsOfGifts.toLowerCase())
                        ).length === 0 ? (
                          <MenuItem disabled sx={{ p: 1 }}>
                            <Typography variant="body2" color="textSecondary">
                              No id's Of Gifts found matching "
                              {searchTermIdsOfGifts}"
                            </Typography>
                          </MenuItem>
                        ) : (
                          IdsOfGifts.filter(
                            (option) =>
                              option.label
                                .toLowerCase()
                                .includes(searchTermIdsOfGifts.toLowerCase()) ||
                              option.value
                                .toString()
                                .toLowerCase()
                                .includes(searchTermIdsOfGifts.toLowerCase())
                          ).map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              <Checkbox
                                style={{ paddingTop: 3 }}
                                icon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  />
                                }
                                checkedIcon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 10,
                                        height: 10,
                                        backgroundColor: "black",
                                      }}
                                    />
                                  </Box>
                                }
                                checked={selectedValuesIdsOfGifts.includes(
                                  option.value
                                )}
                                sx={{ padding: 0 }}
                              />
                              <ListItemText
                                primary={option.label}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: 14,
                                    margin: 0,
                                  },
                                }}
                              />
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>

                <div style={{ display: "flex", width: "100%" }}>
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Actions Filter
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{
                      paddingBottom: 30,
                      //width: MyWidth <= 1024 ? "90%" : "80%",
                      width: "100%",
                      fontSize: 10,
                      //paddingTop: 30,
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="Type offer name"
                        id="standard-basic"
                        name="typeOfferName" // Important: matches the property name in state
                        value={ProductOBJ.typeOfferName}
                        onChange={handleInputChange} // Use the shared handler
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                            },
                          },
                        }}
                      >
                        {TypeOfferName.map((option) => (
                          <MenuItem
                            key={option.value}
                            style={{ fontSize: 14 }}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>

                <button
                  style={{
                    //marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                  }}
                  onClick={() => {
                    //handleSignup();
                    //when do the create use this for dates!!
                    // if (DateOfBirth !== null) {
                    //   formattedDate = ProductOBJ.dateStart.format("DD-MM-YYYY");
                    // }
                  }}
                >
                  <a style={{ fontSize: 14 }}>Create</a>
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  };
  return (
    <div>
      {ModalCreateNewProduct()}
      <button
        style={{
          //marginTop: 20,
          backgroundColor: "#27272a",
          color: "#fff",
          border: "none",
          //padding: "10px 20px",
          cursor: "pointer",
          fontSize: "16px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 50,
        }}
        onClick={async () => {
          await fetchData();
          setOpen(true);
        }}
      >
        <a onClick={() => {}} style={{ cursor: "pointer" }}>
          Create new News
        </a>
      </button>
    </div>
  );
}
